
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function TeamMembershipDefaultMessage() 
{
    const { team } = useCTAL();

    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p><b>No Team Invitations Sent or Join Requests Received yet!</b></p>

                    <p><b>Team Invitations</b> - Team Administrators can invite Users by using their UserName (example: 'JSmith'), Email address, or Phone Number. 
                       Please note that these searches are <u>not</u> case-sensitive (i.e., you don't have to worry about capitalization. example: 'newuser' = 'NewUser') and you
                       don't have to worry about special characters in a Phone Number or an extra period in an Email Address.</p>
                    
                    <p><b>Note:</b> If an existing app User is not found when sending a Team Invitation, an Outside Invitation will automatically be sent either by Email or 
                        SMS Text Message depending the Team Admin's selection.</p>

                    <p><b>Team Join Requests</b> - If a User already knows this Team's Name they can send the Team a Join Request. While this Team Search is also <u>not</u> case-sensitive it 
                       does require an exact match (example: Teams 'New Team' is not the same as 'New Team A').</p>
                    
                    <p>Team Admins must either accept a User's Join Request or a User must Accept a Team's Invitation for the Team to show up in a User's List Index and in the Team's Member List</p>

                    <p><b>Final Note:</b> Both Team Names and UserNames (example UserName: 'JSmith') are <u>unique</u> within Call to Action List to help assure proper Team access.</p>
                    
                    <p>Let's get going!</p>
                </small>
            </div>
        </> 
    );
}